<sd-ymap
  *ngIf="shopGeoObjects$ | async as shopGeoObjects"
  [geoObjects]="shopGeoObjects"
  [isClustered]="true"
  (created)="onMapCreated($event)"
></sd-ymap>
